export const assetTypeTranslations = {
  crypto: 'Crypto',
  stock: 'Stock',
  mutual_fund: 'Mutual fund',
  etf: 'ETF',
  commodity: 'Commodity',
  eltif: 'Eltif',
  empty: 'Empty',
  euro_fund: 'Euro fund',
  structured_product: 'Structured product',
  ccb: 'CCB',
};
